import {AnyAction} from "redux";
import {CHOOSE_ANSWER} from "../actions/action";


//  define selectors

export const getSelectedAnswer = state => state.answer;

//  define the initial state

const initialState: number = null;


/**
 * reducer: set the id of the chosen answer
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function answer(state: number = initialState, action: AnyAction): number
{
    switch (action.type)
    {
        case CHOOSE_ANSWER:
        {
            const {payload} = action;
            const {answer_id} = payload;

            return answer_id;
        }

        default:

            return state;
    }
}


// WEBPACK FOOTER //
// ./src/ts/store/reducers/answer.ts